export const cardHeading = {
    color: "#FFFFFF",
    fontSize: "20px",
    fontWeight: 400,
    // paddingLeft: "15px"
}
export const cardSubHeading = {
    color: "#909090",
    fontSize: "14px",
    fontWeight: 400,
}
export const actionCardStyles = {
    textAlign: "left",
}
export const cardHeaderStyle = {
    display: "flex",
    justifyContent: 'start',
    alignItems: "center",
    paddingLeft: "60px",
}
export const cardHeaderStyle2 = {
    display: "flex",
    justifyContent: 'space-between',
    alignItems: "center",
    paddingLeft: "60px",
    paddingBottom: 0,
}

export const tempStyle = {
    // color: "#FFFFFF",
    fontSize: 48,
    fontWeight: 400,
    background: "linear-gradient(104.58deg, #E7F011 1.18%, #BDFF00 107.13%)",
    backgroundClip: "text",
    textFillColor: "transparent"

}


// Conf room styles 

export const displayConf = { display: "flex", justifyContent: "space-around", alignItems: "center" }

